export default "__VITE_ASSET__D74J9k0l__"